import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Route, Switch, useLocation } from "react-router-dom"
import { authenticationService, configService, queueService } from "./services";
import PrivateRoute from './PrivateRoute';
import Logout, { LogoutPath } from './pages/Logout';
import Home, { HomePath } from './pages/Home';
import {load as loadConfig } from './store/slices/configSlice';
import {load as loadSalesAreas, getAllAreas } from './store/slices/salesAreaSlice';
import { load as loadBookings } from './store/slices/bookingSlice';
import { load as loadLeadSources } from './store/slices/leadSourceSlice';
import Config, { ConfigPath } from "./pages/Config";
import ReadyToDial, { ReadyToDialPath } from "./pages/ReadyToDial";
import CallLogs, { CallLogsPath } from "./pages/CallLogs";
import './App.css';
import Page from "./components/Page/MainPage";
import Campaigns, { CampaignPath } from "./pages/Campaigns";
import CampaignUsers, { CampaignUserPath } from "./pages/CampaignUsers";
import {load as loadPipedriveUsers } from "./store/slices/pipedriveUserSlice";
import { campaignService } from "./services/campaigns.service";
import { loadCampaigns, loadRuleTypes } from "./store/slices/campaignSlice";
import CallQueue, { CallQueuePath } from "./pages/CallQueue";
import Duplicates, { DuplicatePath } from "./pages/Duplicates";
import CallAttemptsPage, { CallAttemptsPath } from "./pages/CallAttempts";
import Dashboard, { DashboardPath } from "./pages/Dashboard";
import ExportPage, { ExportPath } from "./pages/Exports";
import EntraAuth, { EntraAuthPath } from "./pages/EntraAuth";

function App() {
  const [ loggedIn, setLoggedIn ] = useState(authenticationService.currentUserValue);
  const dispatch = useDispatch();
  let location = useLocation();

  useEffect(() => {
    authenticationService.currentUser.subscribe(x => {
      setLoggedIn(authenticationService.currentUserValue);
    });
  }, [authenticationService.currentUserValue]);

  useEffect(() => {
    //fetch data if we have logged in
    if (loggedIn) {
      configService.getConfig().then((config) => {
        if (config.Success) {
          //set the config to store
          dispatch(loadConfig(config.Data.Config));
          let saData = [];
          //process sales areas and put them in store
          Object.keys(config.Data.AvailableSalesAreas).forEach(k => {
            saData.push({
              ID: config.Data.AvailableSalesAreas[k],
              Label: k
            });
          });
          let lsData = [];
          //process sales areas and put them in store
          Object.keys(config.Data.AvailableLeadSources).forEach(k => {
            lsData.push({
              ID: config.Data.AvailableLeadSources[k],
              Label: k
            });
          });
          dispatch(loadLeadSources(lsData));
          dispatch(loadSalesAreas(saData));
          dispatch(loadBookings(config.Data.BookingInfo))
        } else {
          //TODO
          //Something went wrong, display an error message
        }
      })
      queueService.getPipedriveUsers().then(resp => {
        if (resp.Success) {
          dispatch(loadPipedriveUsers(resp.Data))
        }
      })
      .catch(err => {
        console.error(err)
      })
      campaignService.getRuleTypes().then(resp => {
            if (resp.Success) {
                if (resp.Data.Campaigns.length > 0) {
                    resp.Data.Campaigns.forEach((c, i) => {
                        resp.Data.Campaigns[i].Rules.forEach((r, ix) => {
                            resp.Data.Campaigns[i].Rules[ix].Values = resp.Data.Campaigns[i].Rules[ix].Values.split(",")
                        })
                    })
                    dispatch(loadCampaigns(resp.Data.Campaigns));
                }
                if (resp.Data.RuleTypes.length > 0) {
                    dispatch(loadRuleTypes(resp.Data.RuleTypes));
                }
            }
        })
        .catch(err => {
            console.error(err)
        })
    }
  }, [])

  return (
    <>
      <Page>
        <Route exact path={EntraAuthPath} component={EntraAuth} />
        <Route exact path={HomePath} component={Home} />
        <Route path={LogoutPath} component={Logout} />
        <PrivateRoute path={DashboardPath} component={Dashboard} />
        <PrivateRoute path={CallAttemptsPath} component={CallAttemptsPage} />
        <PrivateRoute path={ConfigPath} component={Config} />
        <PrivateRoute path={CampaignPath} component={Campaigns} />
        <PrivateRoute path={CampaignUserPath} component={CampaignUsers} />
        <PrivateRoute path={ReadyToDialPath} component={ReadyToDial} />
        <PrivateRoute path={CallLogsPath} component={CallLogs} />
        <PrivateRoute path={CallQueuePath} component={CallQueue} />
        <PrivateRoute path={DuplicatePath} component={Duplicates} />
        <PrivateRoute path={ExportPath} component={ExportPage} />
          {/* <Switch>
            <PrivateRoute exact path={CalendarPath + "/:calendar"} component={Calendar} />
          </Switch>
          <Switch>
            <PrivateRoute path={CalendarPath + "/:calendar/:startDate"} component={Calendar} />
          </Switch> */}
      </Page>
    </>
  );
}

export default App;
